import React, { useEffect, useState } from "react";
import StartComponent from "./StartComponent";

const StartEngine = ({ config }) => {

    return (
        <StartComponent config={config} />
    );
};

export default StartEngine;
